const departmentRouter = [
    {
        path: "list-department",
        name: "department",
        component: () => import("@/views/admin/department"),
        default: true,
        meta: {
            model: "department",
            // requiresAuth: true,
        },
    },
    {
        path: "list-department/add",
        name: "addDepartment",
        component: () => import("@/views/admin/department/function"),
        default: true,
        meta: {
            model: "department",
            // requiresAuth: true,
        },
    },
    {
        path: "list-department/edit/:id",
        name: "editDepartment",
        component: () => import("@/views/admin/department/function"),
        default: true,
        meta: {
            model: "department",
            // requiresAuth: true,
        },
    }
]
export default departmentRouter;